import React, { useState, useEffect, useRef } from 'react'
import { useQuery } from '@apollo/client';
import * as d3 from 'd3';
import { GET_ONE_FEDERAL_INCOME_DATA,
    GET_ONE_FEDERAL_INCOME_DATA_PROVINCE,
    GET_ONE_FEDERAL_INCOME_DATA_CANADA
} from '../../../../apollo/queries';

//import data from './XYZ.csv';
import './bar.css';
import ReactGA from 'react-ga';

const WealthGraph = (props) => {

    var graph;
    var svg;

    const parentgraph = useRef(null);
    const d3Container = useRef(null);
    const margin = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    }
    const [theWidth, setTheWidth] = useState(0);
    const [theMode, setTheMode] = useState('riding');
    var yScale;
    var jsondata;
    var percentage;
    var totalPopulation;
    var tooltipDiv;
    const country_id = 'canada';

    var height = 500;

    function compare( a, b ) {
        if ( a.hid < b.hid ){
          return -1;
        }
        if ( a.hid > b.hid ){
          return 1;
        }
        return 0;
    }
    
    const [incomeDataRiding, setIncomeDataRiding] = useState(null);
    const [incomeDataProvince, setIncomeDataProvince] = useState(null);
    const [incomeDataCanada, setIncomeDataCanada] = useState(null);

    var prov = null;

    if (String(props.ld).substr(0,2) === "10") {
      prov = "NL"
    } else if (String(props.ld).substring(0,2) === "11") {
      prov = "PE"
    } else if (String(props.ld).substring(0,2) === "12") {
      prov = "NS"
    } else if (String(props.ld).substring(0,2) === "13") {
      prov = "NB"
    } else if (String(props.ld).substring(0,2) === "24") {
      prov = "QC"
    } else if (String(props.ld).substring(0,2) === "35") {
      prov = "ON"
    } else if (String(props.ld).substring(0,2) === "46") {
      prov = "MB"
    } else if (String(props.ld).substring(0,2) === "47") {
      prov = "SK"
    } else if (String(props.ld).substring(0,2) === "48") {
      prov = "AB"
    } else if (String(props.ld).substring(0,2) === "59") {
      prov = "BC"
    } else if (String(props.ld).substring(0,2) === "60") {
      prov = "YT"
    } else if (String(props.ld).substring(0,2) === "61") {
      prov = "NT"
    } else {
      prov = "NU"
    }

    const { loading3, error3, data3 } = useQuery(GET_ONE_FEDERAL_INCOME_DATA, {onCompleted: setIncomeDataRiding,
        variables: { local_division:String(props.ld) }
      });
    
      const { loading4, error4, data4 } = useQuery(GET_ONE_FEDERAL_INCOME_DATA_PROVINCE, {onCompleted: setIncomeDataProvince,
        variables: { province_id:String(props.ld).substr(0,2) }
      });
    
      const { loading5, error5, data5 } = useQuery(GET_ONE_FEDERAL_INCOME_DATA_CANADA, {onCompleted: setIncomeDataCanada,
        variables: { country:country_id }
      });  

    tooltipDiv = d3.select("body").append("div")
    .attr("class", "tooltip")
    .style("opacity", 0);

    const updateBars = (a) => {
        var thedata;
        if (a === 'province') {
            setTheMode('province');
            thedata = incomeDataProvince.getFederalIncomeProvince;
            thedata.sort( compare );
            ReactGA.event({
                category: "Income Graph",
                action: "click",
                label: "province "+props.ld,
            });
        } else if (a === 'canada') {
            setTheMode('canada');
            thedata = incomeDataCanada.getFederalIncomeCanada;
            thedata.sort( compare );
            ReactGA.event({
                category: "Income Graph",
                action: "click",
                label: "canada "+props.ld,
            });            
        } else {
            setTheMode('riding');
            thedata = incomeDataRiding.getFederalIncome;
            ReactGA.event({
                category: "Income Graph",
                action: "click",
                label: "riding "+props.ld,
            });            
        }
        
        var maxValue = Math.ceil(Math.max(
            d3.max(thedata, function(d) {
                return d.value;
            })
        ));

        percentage = function(d) {
            return d / totalPopulation * 100;
        };

        totalPopulation = d3.sum(thedata, function(d) {
            return d.value;
        });

        yScale = d3.scaleLinear().range ([parentgraph.current.offsetHeight, 0]);
        yScale.domain([0, d3.max(thedata, function(d) { return d.value; })]);
        
        d3
        .select("#bars")
        .selectAll("rect")
        .data(thedata)
        .on("mouseover", function(event, d) {
            tooltipDiv.transition()
                .duration(200)
                .style("opacity", 0.9);
            tooltipDiv.html("<strong>Income range: "+d.name+"</strong>" +
                    "<br />  People: " + prettyFormat(d.value) +
                    "<br /> Percentage of total with income: " +percentage(d.value).toFixed(2) + "%")
                .style("left", (event.pageX) + "px")
                .style("top", (event.pageY - 28) + "px");
        })
        .on("mouseout", function(d) {
            tooltipDiv.transition()
                .duration(500)
                .style("opacity", 0);
        })        
        .transition()
        .duration(1000)        
        .attr("y", function(d) { return yScale(d.value); })
        .attr("height", function(d) { return height - yScale(d.value); })

        d3
        .select("#yaxis")
        .transition()
        .duration(1000)
        .call(d3.axisLeft(yScale).tickFormat(function(d){
            return + d;
        }).ticks(10))
        // .on("mouseover", function(event, d) {
        //     tooltipDiv.transition()
        //         .duration(200)
        //         .style("opacity", 0.9);
        //     tooltipDiv.html("<strong>Income range: "+d.name+"</strong>" +
        //             "<br />  People: " + prettyFormat(d.value))
        //         .style("left", (event.pageX) + "px")
        //         .style("top", (event.pageY - 28) + "px");
        // })        
    }

    var style = {
        leftBarColor: '#6c9dc6',
        rightBarColor: '#de5454',
        tooltipBG: '#fefefe',
        tooltipColor: 'black'
    };

    const translation = (x, y) => {
        return 'translate(' + x + ',' + y + ')';
    }

    const colorTransform = (c1, c2) => {
        var c1 = c1.replace('#',''),
            origHex = {
                r: c1.substring(0, 2),
                g: c1.substring(2, 4),
                b: c1.substring(4, 6)
            },
            transVec = {
                r: c2.substring(0, 2),
                g: c2.substring(2, 4),
                b: c2.substring(4, 6)
            },
            newHex = {};

        function transform(d, e) {
            var f = parseInt(d, 16) + parseInt(e, 16);
            if (f > 255) {
                f = 255;
            }
            return f.toString(16);
        }
        newHex.r = transform(origHex.r, transVec.r);
        newHex.g = transform(origHex.g, transVec.g);
        newHex.b = transform(origHex.b, transVec.b);
        return '#' + newHex.r + newHex.g + newHex.b;
    }

    const prettyFormat = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    useEffect(
        () => {
                    if (prov !== null && incomeDataRiding !== null && incomeDataCanada !== null && incomeDataProvince !== null && props.ld !== null && d3Container.current) {
                        
                        if (theMode === 'riding') {
                            jsondata = incomeDataRiding.getFederalIncome;
                        } else if (theMode === 'province') {
                            jsondata = incomeDataProvince.getFederalIncomeProvince;
                        } else {
                            jsondata = incomeDataCanada.getFederalIncomeCanada;
                        }

                        window.addEventListener("resize", handleResize);
                        handleResize();
    
                        function handleResize() {
                            setTheWidth(parentgraph.current.offsetWidth - (margin.left + margin.right));
    
                            percentage = function(d) {
                                return d / totalPopulation * 100;
                            };
                        
                            totalPopulation = d3.sum(jsondata, function(d) {
                                return d.value;
                            });

                            //xScale = d3.scaleBand().range ([0, parentgraph.current.offsetWidth - margin]).padding(0.4);
                            // xScale = d3.scaleLinear().range([0, (((parentgraph.current.offsetWidth - (margin.left + margin.right))/2) - margin.middle)]).domain([0, maxValue]).nice();
                            // yScale = d3.scaleLinear().range ([parentgraph.current.offsetHeight - margin, 0]);
                            // xScale.domain(jsondata.map(function(d) { return d.name; }));
                            // yScale.domain([0, d3.max(jsondata, function(d) { return d.value; })]);
                            try {
                                d3.select("#bars").remove();
                                d3.select("#yaxis").remove();
                                d3.select("#xaxis").remove();
                                             
                                var xScale = d3.scaleBand().range([0, parentgraph.current.getBoundingClientRect().width]).padding(0.4);
                                var yScale = d3.scaleLinear().range([height, 0]);
                                xScale.domain(jsondata.map(function(d) { return d.name; }));
                                yScale.domain([0, d3.max(jsondata, function(d) { return d.value; })]);

                                if (graph !== undefined) { 
                                    graph.append("g")
                                    .attr("id","xaxis")
                                    .call(d3.axisBottom(xScale))
                                    .attr('transform', translation(0, height))
                                    .selectAll('text')
                                    .style('font-size', '10px')
                                    .style('text-anchor','start')
                                    .style('transform', 'rotate(90deg) translate(15px, -13px)');

                                    graph.append("g")
                                    .attr("id", "yaxis")
                                    .attr('transform', translation(0, 0))
                                    .call(d3.axisLeft(yScale).tickFormat(function(d){
                                        return + d;
                                    }).ticks(10))

                                    graph.append('g')
                                    .attr('id', 'bars')
                                    .selectAll(".bar")
                                    .data(jsondata)
                                    .enter().append("rect")
                                    .attr("class", "bar")
                                    .attr("x", function(d) { return xScale(d.name); })
                                    .attr("y", function(d) { return yScale(d.value); })
                                    .attr("width", xScale.bandwidth())
                                    .attr("height", function(d) { return height - yScale(d.value); })
                                    .on("mouseover", function(event, d) {
                                        tooltipDiv.transition()
                                            .duration(200)
                                            .style("opacity", 0.9);
                                        tooltipDiv.html("<strong>Income range: "+d.name+"</strong>" +
                                                "<br />  People: " + prettyFormat(d.value) +
                                                "<br /> Percentage of total: " +percentage(d.value).toFixed(2) + "%")
                                            .style("left", (event.pageX) + "px")
                                            .style("top", (event.pageY - 28) + "px");
                                    })
                                    .on("mouseout", function(d) {
                                        tooltipDiv.transition()
                                            .duration(500)
                                            .style("opacity", 0);
                                    });
                                }

                                
                            } catch (err1) {
                                //console.log(err1);
                            }

                        }

                        var styleSection = d3.select(d3Container.current).append('style')
                        .text(` svg {
                                    max-width:100%
                                }
                                .axis line,axis path {
                                    shape-rendering: crispEdges;
                                    fill: transparent;stroke: #555;
                                }
                                .bar {
                                    fill-opacity: 0.5; 
                                    font-size: 10px; 
                                    fill: ' + style.leftBarColor + ';
                                }
                                .bar:hover {
                                    fill: ${colorTransform(style.leftBarColor, '333333')};
                                }
                                .tooltip {
                                    position: absolute;
                                    line-height: 1.1em;
                                    padding: 7px; 
                                    margin: 3px;
                                    background: ${style.tooltipBG}; 
                                    color: ${style.tooltipColor}; 
                                    pointer-events: none;
                                    border-radius: 8px;
                                }`)

                        var maxValue = Math.ceil(Math.max(
                            d3.max(jsondata, function(d) {
                                return d.value;
                            })
                        ));

                        totalPopulation = 0;
                        percentage = 0;

                        percentage = function(d) {
                            return d / totalPopulation * 100;
                        };

                        totalPopulation = d3.sum(jsondata, function(d) {
                            return d.value;
                        });

                        // tooltipDiv = d3.select("body").append("div")
                        // .attr("class", "tooltip")
                        // .style("opacity", 0);
    
                        const svg = d3.select(d3Container.current)
                        .attr("width", parentgraph.current.getBoundingClientRect().width);

                        graph = svg.append('g')
                            .attr('class', 'inner-region')
                            .attr('id', 'inner-region')
                            .attr('transform', translation(margin.left, margin.top));

                        const width = parentgraph.current.offsetWidth - (margin.left + margin.right);
                        setTheWidth(parentgraph.current.offsetWidth - (margin.left + margin.right));
                        //const width = svg.attr("width") - margin;
                        svg.attr("width", parentgraph.current.getBoundingClientRect().width)
                        const height = svg.attr("height") - (margin.top + margin.bottom);
            
                        var xScale = d3.scaleBand().range ([0, parentgraph.current.getBoundingClientRect().width]).padding(0.4);
                        var yScale = d3.scaleLinear().range ([height, 0]);

                        graph = svg.append("g")
                        .attr("id","gtransform")
                        .attr("transform", "translate(" + 20 + "," + 25 + ")");
            
                        xScale.domain(jsondata.map(function(d) { return d.name; }));
                        yScale.domain([0, d3.max(jsondata, function(d) { return d.value; })]);
            
                        graph.append("g")
                        .attr("id","xaxis")
                        .attr("transform", "translate(0," + height + ")")
                        .call(d3.axisBottom(xScale))
                        .selectAll('text')
                        .style('font-size', '10px')
                        .style('align', 'left')
                        .style('text-anchor','start')
                        .style('transform', 'rotate(90deg) translate(15px, -13px)');
    
                        graph.append("g")
                        .attr("id", "yaxis")
                        .call(d3.axisLeft(yScale).tickFormat(function(d){
                            return d;
                        }).ticks(10))

                        graph.append("g")
                        .attr("id", "bars")
                        .selectAll(".bar")
                        .data(jsondata)
                        .enter().append("rect")
                        .attr("class", "bar")
                        .attr("x", function(d) { return xScale(d.name); })
                        .attr("y", function(d) { return yScale(d.value); })
                        .attr("width", xScale.bandwidth())
                        .attr("height", function(d) { return height - yScale(d.value); })
                        .on("mouseover", function(event, d) {
                            tooltipDiv.transition()
                                .duration(200)
                                .style("opacity", 0.9);
                            tooltipDiv.html("<strong>Income range: "+d.name+"</strong>" +
                                    "<br />  People: " + prettyFormat(d.value) +
                                    "<br /> Percentage of total with income: " +percentage(d.value).toFixed(2) + "%")
                                .style("left", (event.pageX) + "px")
                                .style("top", (event.pageY - 28) + "px");
                        })
                        .on("mouseout", function(d) {
                            tooltipDiv.transition()
                                .duration(500)
                                .style("opacity", 0);
                        });

                        handleResize();

                        return () => window.removeEventListener("resize", handleResize);
            
                    }
                
        },[parentgraph, d3Container, incomeDataRiding, incomeDataProvince, incomeDataCanada])


    return (
        <div>
        {theMode === "riding" ? <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary active" onClick={() => updateBars('riding')}>This Riding</button> : <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary" onClick={() => updateBars('riding')}>This Riding</button> } 
        {theMode === "province" ? <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary active" onClick={() => updateBars('province')}>Province ({prov})</button> : <button style={{marginRight:'5px'}} className="btn btn-sm btn-outline-primary" onClick={() => updateBars('province')}>Province ({prov})</button> } 
        {theMode === "canada" ? <button className="btn btn-sm btn-outline-primary active" onClick={() => updateBars('canada')}>Canada</button> : <button className="btn btn-sm btn-outline-primary" onClick={() => updateBars('canada')}>Canada</button> }
        <div ref={parentgraph} style={{width:'100%', display: 'flex', flexDirection: 'column'}}>
        <svg
            className="d3-component"
            id="svg-income"
            height={500}
            width={theWidth+(margin.left + margin.right)}
            viewBox={`0 0 ${theWidth+(margin.left + margin.right)} 600`}
            preserveAspectRatio="xMidYMid meet"
            ref={d3Container}
        />
        </div></div>
    )
  }
  
  export default WealthGraph;